<template>
  <UserCommonLayout>
    <template #content>
      <LazySkillAdvanceDetail
          v-if="isLoading"
          :advance="skillAdvanceData"
          :advance-type="SkillAdvanceType.PRACTICE"
          :lang-data="lang"
      />
    </template>
  </UserCommonLayout>
</template>

<script setup lang="ts">
import {LazySkillAdvanceDetail, UserCommonLayout} from "#components";
import {useNuxtApp} from "#app";
import {useTrackService} from "~/composables/service/useTrackService";
import {TrackModel} from "~~/package/mapper/track/model/TrackModel";
import {useLoadingStore} from "~/store/loading/loadingStore";
import {useI18n} from "vue-i18n";
import {SkillAdvanceType} from "~~/package/mapper/track/model/SkillAdvanceType";

// TSK-11215: no sessionOwner meta here on purpose. This is not a SkillCertify assessment — the
// termination popup's copy and i18n keys (SkillCertify-duplicate-session-warning-*) are
// SkillCertify-specific, and this route has no assessmentId param, so the popup's 확인 button
// would send the user to "/" instead of back to what they were doing.

const { t } = useI18n();
const {$i18n} = useNuxtApp();
const lang = computed(() =>
    $i18n.locale.value.toUpperCase()
);
const loadingStore = useLoadingStore();
const isLoading = ref(false);
const skillAdvanceData = ref(new TrackModel());
const skillAdvanceId = ref(0);
const route = useRoute();
const router = useRouter();

onMounted(() => {
  skillAdvanceId.value = parseInt(route.params.practiceId as string)
  initData();
});

const initData = () => {
  Promise.all([useTrackService().getTrack(skillAdvanceId.value, lang.value, SkillAdvanceType.PRACTICE)]).then(resolve => {
    skillAdvanceData.value = resolve[0];
    loadingStore.closeLoading();
    isLoading.value = !loadingStore.show;
  })
}

const getSkillAdvanceData = (id: number) => {
  useTrackService().getTrack(id, lang.value).then(track => {
    skillAdvanceData.value = track;
  });
}

watch($i18n.locale, () => {
  getSkillAdvanceData(skillAdvanceId.value);
});
</script>
